import type { NextPage } from 'next';
import HomeSafetySolutionComponent from '@components/projects/home-safety-solution/home-safety-solution';
import ProjectLayout from '@layouts/project-layout/project-layout';
import { ProjectProps } from '@models/project.interface';

const HomeSafetySolution: NextPage<ProjectProps> = (project) => {
  return (
    <ProjectLayout project={project}>
      <HomeSafetySolutionComponent breadcrumbsText={project.project.breadcrumbsText} />
    </ProjectLayout>
  );
};

export default HomeSafetySolution;
export { getServerSideProps } from '@layouts/project-layout/project-layout';
